var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartbar2"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":'bar2Serise' + _vm.idhash}}),(_vm.data[0].length == 0)?_c('div',{staticClass:"nodata"},[_vm._v("暂无数据")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }